import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

/**
 * Format Athena metrics bucket labels for chart axes (matches service dashboard mapper).
 * @param {string} label
 * @param {'daily'|'weekly'|'monthly'} interval
 */
export function formatMetricLabel(label, interval) {
    if (interval === 'monthly') {
        const parts = String(label).split('-');
        if (parts.length >= 2) {
            return dayjs(`${parts[0]}-${parts[1]}-01`).format('MMM');
        }
    }
    const m = dayjs(label);
    if (!m.isValid()) return String(label);
    if (interval === 'daily') return m.format('MMM D');
    if (interval === 'weekly') return `W${m.isoWeek()}`;
    return m.format('MMM');
}

/**
 * Map `/api/analytics/:aba/metrics` rows into ToggleBarChart row shape.
 * @param {Array<{ label: string, opt_in?: number, enrolled?: number, active?: number }>} metricsRows
 * @param {'daily'|'weekly'|'monthly'} interval
 * @param {Record<string, string>} fieldMap chart series key → API field
 */
export function mapAnalyticsMetricsToChartRows(metricsRows, interval, fieldMap) {
    const rows = Array.isArray(metricsRows) ? metricsRows : [];
    return rows.map((row) => {
        const out = { period: formatMetricLabel(row.label, interval) };
        for (const [chartKey, apiKey] of Object.entries(fieldMap)) {
            const value = Number(row[apiKey]);
            out[chartKey] = Number.isFinite(value) ? value : 0;
        }
        return out;
    });
}

export const USER_ADOPTION_FIELD_MAP = {
    optedIn: 'opt_in',
    enrolled: 'enrolled',
    active: 'active',
};

export const ENGAGEMENT_SUMMARY_FIELD_MAP = {
    enrolled: 'enrolled',
    engaged: 'engaged',
    active: 'active',
};
